import { Injectable } from "@angular/core";
import { User } from "@angular/fire/auth";

import { StorageService } from 'anatoliapps-angular/services';

@Injectable({
  providedIn: 'root'
})
export class UserService extends StorageService {

  //#region User Methods
  /**
   * Uploads a profile image for a specific user to Firebase Storage
   * 
   * @param user The Firebase User object containing the user's ID
   * @param profileImage The image blob to be uploaded as profile picture
   * @returns A promise that resolves to the download URL of the uploaded image
   */
  public async uploadProfileImage(user: User, profileImage: Blob): Promise<string> {
    return this.uploadFile(`users/${user.uid}/profile.png`, profileImage, true);
  }
  //#endregion
}